import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full"
}
const _hoisted_2 = { class: "w-full bg-h-primary-100 shadow-sm z-10 select-none h-16 flex items-center" }
const _hoisted_3 = { class: "container mx-auto" }
const _hoisted_4 = { class: "w-full flex justify-between container mx-auto mt-8" }
const _hoisted_5 = { class: "flex flex-row gap-3" }
const _hoisted_6 = {
  key: 0,
  class: "container mx-auto mt-8 h-screen"
}
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Loader, { loader: _ctx.loader }, null, 8, ["loader"]),
    (!_ctx.loader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("labels.generic", {
              pt: "Certificado de conclusão",
              en: "Certificate of completion",
            })), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t("labels.generic", { pt: "Certificado", en: "Certificate" })), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Button, {
                class: "btn-outline-bg-white h-10",
                onClick: _ctx.printPdf
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("labels.generic", { pt: "Imprimir", en: "Print out" })), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_Button, {
                class: "btn-primary h-10",
                onClick: _ctx.downloadPDF
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("labels.generic", {
              pt: "Baixar o certificado",
              en: "Download certificate",
            })), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          (_ctx.url)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("iframe", {
                  ref: "pdfViewer",
                  src: _ctx.url,
                  frameborder: "0",
                  class: "w-full h-[70%] lg:h-[90%]"
                }, null, 8, _hoisted_7)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}